(function ($) {
  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for desktop
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(min-width: 768px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for mobile
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(max-width: 767px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Common JS - All Pages
  ////////////////////////////////////////////////////////////////////////////////////
  var Sage = {
    common: {
      init: function () {

        ////////////////////////////////////////////////////////////////////////////////////
        // AOS - Animate on scroll init
        ////////////////////////////////////////////////////////////////////////////////////
        AOS.init({
          delay: 100, // values from 0 to 3000, with step 50ms
          initClassName: 'aos-init', // class applied after initialization
          animatedClassName: 'aos-animate', // class applied on animation
          duration: 400, // values from 0 to 3000, with step 50ms
          easing: 'ease', // default easing for AOS animations
          once: true, // whether animation should happen only once - while scrolling down
          anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
        });
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Search Functionality
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-init-sitewide-search', function () {

          $('body').toggleClass('site-search-active');
          $(this).toggleClass('active');

          ////////////////////////////////////////////////////////////////////////////////////
          // Show Search
          ////////////////////////////////////////////////////////////////////////////////////
          if ($('.js-section-site-search').is(':hidden')) {
            $('.js-section-site-search').slideDown('slow', function () {
              $('input#search').val('').focus();
            });
          } else {
            $('.js-section-site-search').slideUp('slow');
          }

          ////////////////////////////////////////////////////////////////////////////////////
          // Return False
          ////////////////////////////////////////////////////////////////////////////////////
          return false;

        });
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Dropdown Toggle
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-dropdown-toggle', function () {
          $(this).closest('.nav-item').toggleClass('dropdown-active');

          if ($(this).hasClass('megamenu-toggle')) {
            var dropdownMenu = $(this).next('.dropdown-menu');
            var dropdownMenu_height = dropdownMenu.outerHeight(true);
            var dropdownMenu_image_url = $(this).data('image-url');

            var megamenuImageWrapper = $('body').find('.js-mega-menu-image');
            var nav = $(this).closest('ul.megamenu-nav');

            nav.css('min-height', dropdownMenu_height);
            megamenuImageWrapper.find('img').attr('src', dropdownMenu_image_url);
          }

        });
        ////////////////////////////////////////////////////////////////////////////////////

        //////////////////////////////////////////////////////////////////////////////////////
        // Dropdown hover
        ////////////////////////////////////////////////////////////////////////////////////
        $('.navbar-nav li.dropdown').hover(function() {
          $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(200);
        }, function() {
          $(this).find('.dropdown-menu').stop(true, true).delay(400).fadeOut(200);
        });
        ////////////////////////////////////////////////////////////////////////////////////

        //////////////////////////////////////////////////////////////
        // Animate Hamburger
        //////////////////////////////////////////////////////////////
        
        $(document).on('show.bs.collapse', '.navbar-collapse', function () {
          $('body').addClass('navbar-active');
          $(this).closest('.navbar').addClass('active');
          $(this).closest('.navbar').find('.navbar-toggler').addClass('active');
        });

        $(document).on('hidden.bs.collapse', '.navbar-collapse', function () {
          $('body').removeClass('navbar-active');
          $(this).closest('.navbar').removeClass('active');
          $(this).closest('.navbar').find('.navbar-toggler').removeClass('active');
        });

        $(document).on('keydown', function (e) {
          if (e.key === 'Escape') {
            $('.navbar-collapse.show').collapse('hide');
          }
        });
        ////////////////////////////////////////////////////////////////////////////////////

        //////////////////////////////////////////////////////////////
        // Calculate True VH
        //////////////////////////////////////////////////////////////
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        // We listen to the resize event
        window.addEventListener('resize', () => {
          // We execute the same script as before
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Enable All Popovers
        ////////////////////////////////////////////////////////////////////////////////////
        /*
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
        const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

        if (popoverTriggerList) {
          popoverTriggerList.forEach(function (popoverTriggerEl) {
            popoverTriggerEl.addEventListener('click', function (e) {
              this.classList.toggle('active');
            });
          });
        }
        */

        document.addEventListener('click', (e) => {
          const el = e.target.closest('[data-bs-toggle="popover"]');
          if (!el) return;
          e.preventDefault();
          const moduleSection = el.closest('.section-flexi-hotspot-module');

          // hide any open popovers within the same module
          /*const container = moduleSection || document.body;
          container.querySelectorAll('[data-bs-toggle="popover"][aria-describedby]').forEach((btn) => {
            if (btn !== el) {
              bootstrap.Popover.getInstance(btn)?.hide();
              btn.classList.remove('active');
            }
          });*/

          // Hide ALL open popovers first
          /* document.querySelectorAll('[data-bs-toggle="popover"][aria-describedby]').forEach((btn) => {
            if (btn !== el) {
              bootstrap.Popover.getInstance(btn)?.hide();
              btn.classList.remove('active');
            }
          }); */

          // Hide open popovers from other modules
          document.querySelectorAll('[data-bs-toggle="popover"][aria-describedby]').forEach((btn) => {
            if (btn === el) return;
            const btnModule = btn.closest('.section-flexi-hotspot-module');
            // If different module, hide it
            if (btnModule !== moduleSection) {
              bootstrap.Popover.getInstance(btn)?.hide();
              btn.classList.remove('active');
            }
          });

          const pop = bootstrap.Popover.getOrCreateInstance(el, {
            trigger: 'manual',
            container: moduleSection || el.parentElement, // fallback if not found
            html: true
          });
          if (el.getAttribute('aria-describedby')) {
            pop.hide();
            el.classList.remove('active');
          } else {
            pop.show();
            el.classList.add('active');
          }
        });


        ////////////////////////////////////////////////////////////////////////////////////
        // Chosen Init
        ////////////////////////////////////////////////////////////////////////////////////
        $('body')
          .find('select:not(.not-chosen)')
          .not('.chosen-search-enabled select')
          .each(function () {
            $(this).chosen();
          }
        );
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Sticky Scroll
        ////////////////////////////////////////////////////////////////////////////////////
        sticky_scroll_header();

        sticky_filter_block();
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Accordion
        ////////////////////////////////////////////////////////////////////////////////////
        //$('.accordion').on('hide.bs.collapse show.bs.collapse', function (e) {
        //  $(e.target).closest('.js-accordion-item').toggleClass('active');
        //});

        let hoverTimer = null;
const HOVER_DELAY = 200;
let currentHoverItem = null; // Tracks the currently hovered/open item

// Sync active class
$('.accordion').on('show.bs.collapse hide.bs.collapse', function (e) {
  $(e.target).closest('.js-accordion-item').toggleClass('active');
});

// Delayed hover open
$('.js-accordion-item').on('mouseenter', function () {
  const $item = $(this);

  // If this item is already open/hovered, ignore
  if (currentHoverItem && $item.is(currentHoverItem)) return;

  clearTimeout(hoverTimer);

  hoverTimer = setTimeout(() => {
    const $collapse = $item.find('.collapse');

    // Close all other accordions
    $('.js-accordion-item .collapse.show')
      .not($collapse)
      .stop(true, true)
      .collapse('hide');

    // Open the hovered one
    if (!$collapse.hasClass('show') && !$collapse.hasClass('collapsing')) {
      $collapse.collapse('show');
      currentHoverItem = $item;
    }
  }, HOVER_DELAY);
});

// Close on mouse leave
$('.js-accordion-item').on('mouseleave', function () {
  clearTimeout(hoverTimer);

  const $collapse = $(this).find('.collapse.show');

  if ($collapse.length) {
    $collapse.collapse('hide');
    if (currentHoverItem && $(this).is(currentHoverItem)) {
      currentHoverItem = null;
    }
  }
});


        jQuery(function($) {
          let hoverTimer = null; 
          const delay = 80;
          $('.accordion .accordion-header').hover(function() {
            const header = $(this);
            clearTimeout(hoverTimer);
            hoverTimer = setTimeout(function() {
              const target = header.find('[data-bs-target], [data-target]').attr('data-bs-target') 
                          || header.find('[data-bs-target], [data-target]').attr('data-target');
              if ($(target).hasClass('show')) return;
              $('.accordion .accordion-collapse.show').collapse('hide');
              $(target).collapse('show');
            }, delay);
          });
        });


        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Custom Mouse Pointer
        ////////////////////////////////////////////////////////////////////////////////////
        init_custom_mouse_pointer();
        ////////////////////////////////////////////////////////////////////////////////////


        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Virtual Tour Module
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_virtual_tour_block();
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Virtual Tour Module
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_display_video_block();
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Flip Cards Module
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_flip_cards_module();
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Video Module
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_video_block();
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexi Block: Calendly password gate
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_calendly_block();
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexible Content: Ticker Tape Element
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_ticker_tape('.js-ticker-tape');
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexible Content: Harmony Inclusions
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_harmony_inclusions();
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexible Content: Home Designs Filter Grid
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_home_designs_filter_grid();
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexible Content: H&L Filter Grid
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_house_and_land_filter_grid();
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexible Content: Display Homes Filter Grid
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_display_homes_filter_grid();
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Favourites initialisation (cards + favourites block)
        ////////////////////////////////////////////////////////////////////////////////////
        if (window.nousFavourites && typeof window.nousFavourites.init === 'function') {
          window.nousFavourites.init();
        } else if (typeof flexi_favourite_designs_block === 'function') {
          // Fallback if module is not available for some reason
          flexi_favourite_designs_block();
        }

        ////////////////////////////////////////////////////////////////////////////////////
        // Quote Management (LocalStorage persistence)
        // Similar to nousFavourites, this handles "Add to Quote" interactions across pages.
        // - Tracks selected Home Designs via .js-add-to-quote[data-hd-id]
        // - Stores quote list in localStorage as IDs
        // - Toggles visual state and counter elements
        // - Automatically rehydrates the list for consistent UX
        ////////////////////////////////////////////////////////////////////////////////////
        if (window.nousQuotes && typeof window.nousQuotes.init === 'function') {
          window.nousQuotes.init();
        }
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Flexible Content: Display Homes Block
        ////////////////////////////////////////////////////////////////////////////////////
        flexi_display_homes_block();
        ////////////////////////////////////////////////////////////////////////////////////

        ////////////////////////////////////////////////////////////////////////////////////
        // Flickity safety net — catch carousels that auto-init may have missed
        ////////////////////////////////////////////////////////////////////////////////////
        init_flickity_safety_net();
        ////////////////////////////////////////////////////////////////////////////////////

      }
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Home page
    ////////////////////////////////////////////////////////////////////////////////////
    home: {
      init: function () {}
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Blog
    ////////////////////////////////////////////////////////////////////////////////////
    blog: {
      init: function () {}
    },


    ////////////////////////////////////////////////////////////////////////////////////
    // Home Design Page
    ////////////////////////////////////////////////////////////////////////////////////
    single_home_design: {
      init: function () {

        var hd_info_block = $('.section-home-design-info');
        if (hd_info_block.length) {
          var floorPlanSelect = hd_info_block.find('.js-hd-floorplan');
          floorPlanSelect.on('change', function() {
            var selectedFloor = $(this).val();
            var floorPlanContent = hd_info_block.find('.js-floorplan-content');
            var floorPlanWrapper = hd_info_block.find('.js-floorplan-wrapper');

            floorPlanContent.find('.hd-floor').removeClass('active');
            floorPlanWrapper.find('.floorplan').removeClass('active');
            floorPlanWrapper.find('.floorplan').find('.js-fp-panzoom').removeClass('active').removeAttr('style').hide();

            floorPlanContent.find(`.hd-${selectedFloor}`).addClass('active');
            floorPlanWrapper.find(`.${selectedFloor}`).addClass('active');
            floorPlanWrapper.find(`.${selectedFloor}`).find('.js-fp-panzoom:first').addClass('active').show();

            panControl('.js-fp-panzoom.active');

          });
        }

        panControl('.js-fp-panzoom.active');

      }
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // House & Land Page
    ////////////////////////////////////////////////////////////////////////////////////
    single_hl_packages: {
      init: function () {

        panControl('.js-fp-panzoom');

      }
    }
  };

  ////////////////////////////////////////////////////////////////////////////////////
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  ////////////////////////////////////////////////////////////////////////////////////
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


///////////////////////////////////////////////////////////////
// REFRESH AoS
///////////////////////////////////////////////////////////////
jQuery(window).on("load", function () {
	AOS.init();
  AOS.refresh();
  init_flickity_safety_net();
});

jQuery(window).on('resize', function () {
  AOS.refresh();
});

function refreshAOS() {
  if (!window.AOS) return;

  // wait for DOM paint + layout to settle
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      AOS.refreshHard(); // or AOS.refresh()
    });
  });
}

///////////////////////////////////////////////////////////////
// REFRESH AoS
///////////////////////////////////////////////////////////////
jQuery(function($) {
  const $parent = $('.js-filter-option');
  const $select = $parent.find('.form-select');
  const $placeholder = $select.find('option').first();

  function updateText() {
    if ($(window).width() < 768) {
      $placeholder.text('Sort');
    } else {
      $placeholder.text('Sort By');
    }
  }

  // Run once on load
  updateText();

  // Run again on resize
  $(window).on('resize', updateText);
});


///////////////////////////////////////////////////////////////
// Main Menu Dropdown - MEGA MENU
///////////////////////////////////////////////////////////////
jQuery(document).ready(function($) {
  $('.dropdown-menu-inner').each(function() {
    var $container = $(this);
    var $links = $container.find('.js-dropdown-menu-links');
    var $images = $container.find('.js-dropdown-menu-image');

    // Show default image on load (based on data-parentid)
    var parentId = $images.attr('data-parentid');
    $images.find('img').hide(); // Hide all first
    $images.find('img[data-pagid="' + parentId + '"]').show(); // Show default image

    // On hover — show related image
    $links.on('mouseenter', 'a', function() {
      var pageId = $(this).data('pageid');

      // Only hide images that are currently visible and not the target
      $images.find('img:visible').not('[data-pagid="' + pageId + '"]').stop(true, true).hide(300);

      // Only fade in the target image if it's not already visible
      var $targetImg = $images.find('img[data-pagid="' + pageId + '"]');
      if (!$targetImg.is(':visible')) {
        $targetImg.stop(true, true).fadeIn(200);
      }
    });

    // On mouse leave — restore default image
    $links.on('mouseleave', function() {
      var $targetImg = $images.find('img[data-pagid="' + parentId + '"]');

      // Only hide images that are currently visible and not the default
      $images.find('img:visible').not($targetImg).stop(true, true).hide(300);

      // Only fade in the default if it's not already visible
      if (!$targetImg.is(':visible')) {
        $targetImg.stop(true, true).fadeIn(300);
      }
    });
  });
});




///////////////////////////////////////////////////////////////
// HAMBURGER MENU - MEGA MENU - HOVER EXPAND
///////////////////////////////////////////////////////////////

jQuery(document).ready(function ($) {

  const mq = window.matchMedia('(min-width: 992px)');

  function bindDesktopHover() {

    // Remove existing hover handlers first (important on resize)
    $('header .dropdown.nav-item').off('mouseenter mouseleave');

    if (!mq.matches) return;

    $('header .dropdown.nav-item').each(function () {
      const $obj = $(this);
      const $toggle = $obj.find('.nav-link').next();
      const $menu = $toggle.next();

      $obj.on('mouseenter', function () {
        const dropdownMenu_image_url = $(this).find('.js-dropdown-toggle').data('image-url');
        const megamenuImageWrapper = $('body').find('.js-mega-menu-image');
        megamenuImageWrapper.find('img').attr('src', dropdownMenu_image_url);

        $('header .dropdown.nav-item').not($obj).each(function () {
          $(this)
            .find('.nav-link').next().removeClass('show').attr('aria-expanded', 'false')
            .next('.dropdown-menu').removeClass('show');
        });

        $toggle.addClass('show').attr('aria-expanded', 'true');
        $menu.addClass('show');
      });

      $obj.on('mouseleave', function () {
        $toggle.removeClass('show').attr('aria-expanded', 'false');
        $menu.removeClass('show');
      });
    });
  }

  // Initial run
  bindDesktopHover();

  // Re-evaluate on resize / orientation change
  mq.addEventListener('change', bindDesktopHover);

});



/////////////////////////////////////////////////////////////////
// Filter block UI Select state
/////////////////////////////////////////////////////////////////
jQuery(document).ready(function($) {
  //$('.filter-block-filter select').each(function() {
  $('select.form-select').each(function() {
    var $select = $(this);
    function updateSelectState() {
      var $selectedOption = $select.find('option:selected');
      if (!$selectedOption.is('[default]')) {
        //console.log('FORM SELECT: DEFAULT');
        $select.addClass('has-selection');
      } else {
        //console.log('FORM SELECT: OPTION');
        $select.removeClass('has-selection');
      }
    }
    // Run on load
    updateSelectState();
    // Run on change
    $select.on('change', updateSelectState);
  });
});


jQuery(document).ready(function($) {
  //$('.filter-block-filter select').each(function() {
  $('select.gfield_select').each(function() {
    var $select = $(this);
    function updateSelectState() {
      var $selectedOption = $select.find('option:selected');
      if (!$selectedOption.is('.gf_placeholder')) {
        //console.log('FORM SELECT: DEFAULT');
        $select.addClass('has-selection');
      } else {
        //console.log('FORM SELECT: OPTION');
        $select.removeClass('has-selection');
      }
    }
    // Run on load
    updateSelectState();
    // Run on change
    $select.on('change', updateSelectState);
  });
});



///////////////////////////////////////////////////////////////////////////
// INFO PACK DOWNLOAD
///////////////////////////////////////////////////////////////////////////
jQuery(document).ready(function($) {
  jQuery(function($){
    // For Auto generated PDFs
    // Bound on document in the CAPTURE phase rather than as a jQuery
    // delegated handler. Two things have to hold at once.
    //
    // Buttons injected after page load must be covered, because the favourites
    // list renders its cards over AJAX and a direct binding never sees them.
    //
    // stopPropagation() must still suppress ancestor handlers. The display
    // location card carries an inline onclick that navigates the page, and the
    // original direct binding stopped the click before it reached that. A
    // bubble-phase delegated handler on document runs only after the click has
    // already passed the card, so the page would navigate instead of
    // downloading. Capture on document runs before the click descends to the
    // button, which restores the suppression.
    document.addEventListener('click', function (e) {
        // This runs for every click on every page, so do not assume the target
        // is an Element. A throwing capture listener on document would spam the
        // console sitewide and bury real errors.
        const target = e.target;
        if (!target || typeof target.closest !== 'function') { return; }

        const btn = target.closest('.js-download-trigger');
        if (!btn) { return; }

        e.preventDefault();
        e.stopPropagation();

        const $btn = $(btn);
        const pid = $btn.attr('data-pid');
        const downloadOptions = $btn.attr('data-option');
        const homeDesignTitle = $btn.attr('data-home-title');
        // The button's text includes the indentation and line breaks around
        // its markup, so collapse it to the words a visitor sees.
        const btnText = $btn.text().replace(/\s+/g, ' ').trim();

        /**
         * Pushes the GA download event. Only buttons carrying data-home-title
         * were tracked before, so no events are added elsewhere.
         *
         * @since 1.1.0
         * @returns {void}
         */
        function trackDownload() {
            if (homeDesignTitle && window.dataLayer) {
                window.dataLayer.push({
                    'event': 'gaTriggerEvent',
                    'gaEventCategory': 'Downloads',
                    'gaEventAction': 'pdf',
                    'gaEventLabel': 'Dynamic PDF - ' + homeDesignTitle + ' - ' + btnText
                });
            }
        }

        /**
         * Clears the preloader and tells the visitor the download failed.
         *
         * @since 1.1.0
         * @returns {void}
         */
        function failed() {
            hidePreloader();
            alert('Error generating PDF');
        }

        /**
         * Fetches a cached info pack and hands it to the browser as a download.
         * The preloader is a fixed, full-screen, pointer-events: all overlay,
         * so every path clears it, failures included.
         *
         * @since 1.1.0
         * @param {string} url - Static PDF URL in uploads/hh-info-packs.
         * @param {string} filename - Download file name.
         * @returns {Promise<void>} Rejects when the file cannot be fetched.
         */
        function downloadCached(url, filename) {
            // Each revision of a pack has its own URL, so any cached copy of
            // this URL is the right PDF.
            return fetch(url, { cache: 'no-cache' })
                .then(function (resp) {
                    if (!resp.ok) { throw new Error('HTTP ' + resp.status); }
                    return resp.blob();
                })
                .then(function (blob) {
                    downloadBlob(blob, filename);
                    trackDownload();
                    hidePreloader();
                });
        }

        /**
         * Asks generate_pdf for the info pack, rendering it on the server if
         * needed. In 'url' format the server returns the cached file's URL, or
         * base64 when it cannot cache. If the URL cannot be fetched (a CDN on
         * another origin, say), it asks once more for base64.
         *
         * @since 1.1.0
         * @param {string} format - 'url' or 'base64'.
         * @returns {void}
         */
        function requestPack(format) {
            $.post('/wp-admin/admin-ajax.php', {
                action: 'generate_pdf',
                pid: pid,
                download_options: downloadOptions,
                format: format
            }, function (res) {
                if (res.success && res.data.url) {
                    btn.setAttribute('data-pdf-url', res.data.url);
                    btn.setAttribute('data-pdf-at', String(Date.now()));
                    btn.setAttribute('data-pdf-filename', res.data.filename);
                    downloadCached(res.data.url, res.data.filename).catch(function () {
                        btn.removeAttribute('data-pdf-url');
                        btn.removeAttribute('data-pdf-filename');
                        requestPack('base64');
                    });
                } else if (res.success && res.data.pdf_base64) {
                    downloadBlob(res.data.pdf_base64, res.data.filename);
                    trackDownload();
                    hidePreloader();
                } else {
                    failed();
                }
            })
            .fail(failed);
        }

        showPreloader();

        // A cached info pack is a static file in uploads. The first download
        // on this page asks generate_pdf for its current URL and stores it on
        // the button, so a repeat click fetches the file without admin-ajax.
        // Pages never print the URL: a cached page would keep pointing at a
        // pack that an edit has since replaced.
        // Reuse the URL for five minutes. A page left open longer asks again,
        // in case the design has been edited and the pack has a new URL.
        const pdfAt = Number(btn.getAttribute('data-pdf-at') || 0);
        const cachedUrl = (Date.now() - pdfAt < 5 * 60 * 1000) ? btn.getAttribute('data-pdf-url') : null;
        if (cachedUrl) {
            downloadCached(cachedUrl, btn.getAttribute('data-pdf-filename') || 'info-pack.pdf')
                .catch(function () {
                    // The file was purged after this page was cached. Ask the
                    // server, which renders a fresh one.
                    btn.removeAttribute('data-pdf-url');
                    btn.removeAttribute('data-pdf-filename');
                    requestPack('url');
                });
            return;
        }

        requestPack('url');
    }, true);

    // For existing Media Library PDFs
    $('.js-media-pdf-download').on('click', function(e){
        e.preventDefault();
        const pdfUrl = $(this).attr('href');
        const filename = pdfUrl.split('/').pop();
        showPreloader();
        fetch(pdfUrl)
            .then(resp => resp.blob())
            .then(blob => {
                downloadBlob(blob, filename);
                hidePreloader();
            })
            .catch(err => {
                alert('Error downloading PDF');
                hidePreloader();
            });
    });

    function downloadBlob(data, filename) {
        let blob;
        if (typeof data === 'string') { // Auto generated PDF
            blob = base64ToBlob(data, 'application/pdf');
        } else { // Media library PDF
            blob = data;
        }

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    function base64ToBlob(base64, mime) {
        const byteChars = atob(base64);
        const byteNumbers = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) {
            byteNumbers[i] = byteChars.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], {type: mime});
    }

    function showPreloader() {
        $('.pdf-preloader').addClass('active');
    }
    function hidePreloader() {
        $('.pdf-preloader').removeClass('active');
    }
  });


  ///////////////////////////////////////////////////////////////
  // HD Variant floor plan display 
  ///////////////////////////////////////////////////////////////
  $(document).on('click','.js-variant-pill', function () {
      const variantId = $(this).data('variant-id');
      const varianFps = $(this).closest('.card-body').next();
      // Hide all groups
      varianFps.find('.variant-fp-group').hide();
      // Show matching group
      const $activeGroup = $('.variant-fp-group[data-variant-id="' + variantId + '"]');
      $activeGroup.show();
      const activeLink = $activeGroup.siblings('.js-card-explore-link').attr('href');
      console.log(activeLink);
      $activeGroup.closest('.card-search-home-designs').find('.hd-variant-facade').find('.js-card-explore-link').attr('href',activeLink);

      setTimeout(function(){
        initVariantCarousels($activeGroup.find('.variant-fp-carousel'));
      },100);
  });

  // INIT Carousel
  $('.js-variant-pills').each(function () {
    const obj = $(this);
    const pill = obj.find('.js-variant-pill');
    if(pill.hasClass('is-active')){
      const refid = pill.attr('data-variant-id');
      const $activeGroup = $('.variant-fp-group[data-variant-id="' + refid + '"]');
      $activeGroup.fadeIn();
      setTimeout(function(){
        initVariantCarousels($activeGroup.find('.variant-fp-carousel'));
      },100);
    }
  });

  function initVariantCarousels(context,index=0) {
    $(context).each(function () {
        const $group = $(this);
        const $items = $group.find('.variant-fp-item');
        //if ($items.length > 1) {
            if (!$group.hasClass('flickity-enabled')) {
                $group.flickity({
                    cellSelector: '.variant-fp-item',
                    prevNextButtons: $items.length > 1,
                    pageDots: true,
                    wrapAround: true,
                    adaptiveHeight: true,
                    imagesLoaded: true,
                    initialIndex: index,
                    arrowShape: "m25.21,44.06h66.35c3.28,0,5.94,2.66,5.94,5.94s-2.66,5.94-5.94,5.94H25.21l29.02,29.02c2.33,2.33,2.31,6.11-.04,8.42-2.32,2.28-6.05,2.26-8.35-.04L2.5,50,45.84,6.66c2.3-2.3,6.03-2.32,8.35-.04,2.35,2.31,2.37,6.09.04,8.42l-29.02,29.02Z",
                });
            }
        //}
    });
  }


  ///////////////////////////////////////////////////////////////
  // HD FP Modal Popup
  ///////////////////////////////////////////////////////////////
  
  ////////////////////////////////////////////////////////
  // GLOBAL MODAL ACTIONS
  ////////////////////////////////////////////////////////
  const modalSel = '.flickity-carousel-modal';
  const closeSel = '.js-flickity-carousel-modal-close';
  // Close
  $(document).on('click', closeSel, function (e) {
    e.preventDefault();
    closeModal();
  });
  // Close when clicking outside container
  $(document).on('click', modalSel, function (e) {
    if ($(e.target).closest('.flickity-carousel-modal-container').length) return;
    closeModal();
  });
  // Close on ESC
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function closeModal() {
    const $modal = $(modalSel);
    $modal.fadeOut(150, function () {
      $modal.removeClass('is-loading');
      //$modal.find(contentSel).empty();
    });
  }

  
  ////////////////////////////////////////////////////////
  // HOME-DESIGNS SINGLE VIEW - FLOOR PLAN MODAL
  ////////////////////////////////////////////////////////
  (function ($) {
    // Config
    const CFG = {
      modalSel: modalSel,
      contentSel: '.flickity-carousel-modal-content',
      openBtnSel: '.js-modal-view',
      stackClass: 'modal-image-stack',
      imgClass: 'modal-img w-100 h-auto d-block',
      activeClass: 'is-active',
      preloaderSel: '.flickity-carousel-modal-container-preloader',
      modalContainerSel: '.flickity-carousel-modal-container',
      panzoomContainerSel: '.panzoom-container',
      panzoomSel: '.js-fp-panzoom',
      activePanzoomSel: '.js-fp-panzoom.active:visible'
    };


    // cache of urls already added to modal stack /////////
    const State = {
      urls: new Set(),
      preloadPromises: new Map()
    };


    // DOM Helpers ////////////////////////////////////////
    function $modal() {
      return $(CFG.modalSel);
    }

    function $content() {
      return $modal().find(CFG.contentSel);
    }

    function ensureStack() {
      const $c = $content();
      let $stack = $c.find(`.${CFG.stackClass}`);
      if (!$stack.length) {
        $stack = $(`<div class="${CFG.stackClass}"></div>`);
        $c.append($stack);
      }
      return $stack;
    }

    function $preloader() {
      return $modal().find(CFG.modalContainerSel).find(CFG.preloaderSel);
    }

    function showModal() {
      $modal().fadeIn(150);
    }

    function setPreloaderVisible(isVisible) {
      const $p = $preloader();
      if (!$p.length) return;
      isVisible ? $p.show() : $p.hide();
    }


    // Image helpers //////////////////////////////////////
    function normalizeUrl(url) {
      return (url || '').trim();
    }

    function preload(url) {
      url = normalizeUrl(url);
      if (!url) return Promise.reject(new Error('No URL'));

      // De-dupe loads
      if (State.preloadPromises.has(url)) return State.preloadPromises.get(url);

      const p = new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(url);
        img.onerror = () => reject(new Error(`Failed to load: ${url}`));
        img.src = url;
      });

      State.preloadPromises.set(url, p);
      return p;
    }

    function createStackImg(url) {
      return $('<img>', {
        alt: '',
        class: CFG.imgClass
      }).data('url', url);
    }

    function setActiveModalImage(url) {
      url = normalizeUrl(url);
      if (!url) return;

      const $stack = ensureStack();

      // clear active
      $stack.find(`img.${CFG.activeClass}`).removeClass(CFG.activeClass);

      // activate matching
      const $match = $stack
        .find('img')
        .filter(function () {
          return $(this).data('url') === url;
        })
        .first();

      if ($match.length) $match.addClass(CFG.activeClass);
    }

    // Ensure URL exists in the stack
    function addUrlToStack(url) {
      url = normalizeUrl(url);
      if (!url) return Promise.resolve(false);

      const $stack = ensureStack();

      // Already tracked? ensure it exists in DOM (in case stack was server-rendered)
      if (State.urls.has(url)) return Promise.resolve(true);

      // If it exists in DOM already, track it and exit
      const alreadyInDom = $stack.find('img').filter(function () {
        return $(this).data('url') === url;
      }).length > 0;

      if (alreadyInDom) {
        State.urls.add(url);
        return Promise.resolve(true);
      }

      // Add new
      State.urls.add(url);
      const $img = createStackImg(url);

      return preload(url)
        .then(() => {
          $img.attr('src', url);
          $stack.append($img);
          return true;
        })
        .catch(() => {
          // keep url tracked to prevent infinite retries;
          return false;
        });
    }

    // Add batch of URLs ////////////////////////////////////////
    function addUrlsToStack(urls) {
      const unique = [...new Set((urls || []).map(normalizeUrl).filter(Boolean))];
      return Promise.all(unique.map(addUrlToStack));
    }

    // Panzoom helpers ////////////////////////////////////////
    function getPanzoomContainerFromBtn($btn) {
      return $btn.closest(CFG.panzoomContainerSel);
    }

    function getAllImageUrlsFromPanzoom($pzContainer) {
      if (!$pzContainer || !$pzContainer.length) return [];
      return $pzContainer
        .find(`${CFG.panzoomSel} img`)
        .map(function () {
          return this.currentSrc || this.src || '';
        })
        .get()
        .map(normalizeUrl)
        .filter(Boolean);
    }

    function getActiveImageUrlFromPanzoom($btn) {
      const $pzContainer = getPanzoomContainerFromBtn($btn);
      const $activePanzoom = $pzContainer.find(CFG.activePanzoomSel).first();
      const imgEl = $activePanzoom.find('img').get(0);
      return normalizeUrl(imgEl && (imgEl.currentSrc || imgEl.src));
    }


    // Main flows ////////////////////////////////////////
    function openFromButton($btn) {
      const $pzContainer = getPanzoomContainerFromBtn($btn);

      // decide active
      const urls = getAllImageUrlsFromPanzoom($pzContainer);
      const activeUrl = getActiveImageUrlFromPanzoom($btn) || urls[0] || '';

      setPreloaderVisible(true);
      showModal();

      // populate then activate
      addUrlsToStack(urls)
        .finally(() => {
          setActiveModalImage(activeUrl);
          setPreloaderVisible(false);
        });
    }

    function initialPopulate() {
      const urls = $(`${CFG.panzoomContainerSel} ${CFG.panzoomSel} img`)
        .map(function () {
          return this.currentSrc || this.src || '';
        })
        .get()
        .map(normalizeUrl)
        .filter(Boolean);

      addUrlsToStack(urls);
    }


    // Event handlers ////////////////////////////////////////
    $(document).on('click', CFG.openBtnSel, function (e) {
      e.preventDefault();
      openFromButton($(this));
    });

    // On ready: ensure stack
    $(function () {
      ensureStack();
      initialPopulate(); //comment out to lazy-load only on open
    });

  })(jQuery);




  ////////////////////////////////////////////////////////
  // HOME-DESIGNS - FLOOR PLAN CAROUSEL (DISABLED)
  ////////////////////////////////////////////////////////
  $(document).on('click','.js-carousel-button', function(){
    const obj = $(this);
    //const fpid = obj.attr('data-variant-id');
    const pills = obj.closest('.variant-fp').prev().find('.variant-pills').find('.variant-pill');
    const selected_pill = pills.filter('.is-active').attr('data-variant-id');
    const fpid = pills.map(function () {
      return $(this).data('variant-id');
    }).get().join(',');

    const hdFpModal = $('.flickity-carousel-modal');
    const spinner = hdFpModal.find('.flickity-carousel-modal-container .hh-spinner');
    spinner.show(300);
    hdFpModal.find('.flickity-carousel-modal-content').html('');
    hdFpModal.show(300);
    
    $.post('/wp-admin/admin-ajax.php', {
      action: 'hd_get_floorplan',
      pid: fpid,
    }, function(res){
      if(res.success){    
        let hdFpHtm = '';
        $.each(res.data, function (index, data) {
          hdFpHtm += `<div class="variant-fp-item d-flex justify-content-center flex-column" data-variant-id="${data.id}">
                        <img src="${data.image_url}" alt="" class="img-fluid object-fit-contain">
                        <div class="w-100 text-center h4">${data.title.split(/\s*(–|-|&#8211;)\s*/)[0].trim()}</div>
                      </div>`;
        });
        hdFpHtm = `<div class="flickity-carousel variant-fp-carousel col-12 d-flex flex-column">${hdFpHtm}</div>`;
        hdFpModal.find('.flickity-carousel-modal-content').html(hdFpHtm);
        //hdFpModal.show(300);
        const index = res.data.findIndex(item => item.id == selected_pill);
        setTimeout(function(){
          initVariantCarousels(hdFpModal.find('.variant-fp-carousel'),index);
          hdFpModal.find('.variant-fp-carousel').css({'opacity':1})
          spinner.hide(300);
        },100)
      } else {
          console.log('Failed');
      }
    })
  });
  
  // DISABLED END


  ////////////////////////////////////////////////////////
  // SEARCH CARDS - FLOOR PLAN EXPAND MODAL
  ////////////////////////////////////////////////////////
  (function ($) {

    $(document).on('click', '.js-fp-expand-btn', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $btn      = $(this);
      var $variantFp = $btn.closest('.variant-fp');

      // Find the currently visible variant floor plan group
      var $visibleGroup = $variantFp.find('.variant-fp-group:visible').first();
      if (!$visibleGroup.length) {
        $visibleGroup = $variantFp.find('.variant-fp-group').first();
      }

      // Get the full-size image URL (fall back to current src)
      var $img    = $visibleGroup.find('.variant-fp-item img').first();
      var fullUrl = $img.attr('data-fp-full') || $img.attr('src') || '';
      if (!fullUrl) return;

      // Reuse the global modal
      var $modal   = $('.flickity-carousel-modal');
      var $content = $modal.find('.flickity-carousel-modal-content');
      var $spinner = $modal.find('.flickity-carousel-modal-container .hh-spinner');

      // Clear previous content and show modal with spinner
      $content.html('');
      $spinner.show();
      $modal.fadeIn(150);

      // Preload the full-size image then display it
      var img = new Image();
      img.onload = function () {
        $content.html(
          '<div class="modal-image-stack">' +
            '<img src="' + fullUrl + '" alt="" class="modal-img is-active w-100 h-auto d-block">' +
          '</div>'
        );
        $spinner.hide();
      };
      img.onerror = function () {
        // Fallback: show the large thumbnail
        $content.html(
          '<div class="modal-image-stack">' +
            '<img src="' + ($img.attr('src') || '') + '" alt="" class="modal-img is-active w-100 h-auto d-block">' +
          '</div>'
        );
        $spinner.hide();
      };
      img.src = fullUrl;
    });

  })(jQuery);


  ///////////////////////////////////////////////////////////////
  // Floor plan rotation
  ///////////////////////////////////////////////////////////////
  jQuery('.js-rotate-control').on('click', function() {
    const obj = jQuery(this);
    jsFloorPlanRotation += 90; // always clockwise
    const $img = $('.js-fp-panzoom img');
    $img.css({ // Apply rotation
      'transition': 'transform 0.3s ease',
      'transform': 'rotate(' + jsFloorPlanRotation + 'deg)'
    });

    $img.one('transitionend', function() { // Wait for transition to finish
      // If rotation reaches a multiple of 360, reset CSS and rotation variable
      if (jsFloorPlanRotation % 360 === 0) {     
        $img.css('transition', 'none'); // Temporarily disable transition
        $img.css('transform', 'rotate(0deg)');
        jsFloorPlanRotation = 0;
        $img[0].offsetHeight; 
        $img.css('transition', 'transform 0.3s ease');
      }

      
      //-------------------------------------------
      // Find the panzoom container relative to the clicked control
      const pze = obj.closest('.pan-controls').next().find('.js-fp-panzoom');

      // Get the image inside the panzoom container as a DOM element
      const img = pze.find('img')[0]; // <-- [0] to get DOM element
      if (!img) return false;

      // Get the container DOM element
      const container = pze[0]; // <-- [0] to get DOM element
      if (!container) return false;

      // Get bounding rectangles
      const imgRect = img.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      // Check if image overflows the container
      const pzeImgOverflows =
        imgRect.left < containerRect.left ||
        imgRect.top < containerRect.top ||
        imgRect.right > containerRect.right ||
        imgRect.bottom > containerRect.bottom;

      if(pzeImgOverflows){
        panzoom.setOptions({ disablePan: false }); // Enable dragging
        pze.addClass('can-pan');
      } else {
        panzoom.setOptions({ disablePan: true });  // Disable dragging
        pze.removeClass('can-pan');
      }
      //-------------------------------------------   

    })
    
  });


  ///////////////////////////////////////////////////////////////
  // Floor plan Horizontal Flip
  ///////////////////////////////////////////////////////////////
  /*
  jQuery('.js-flip-control').on('click', function () {
    const $floorplan = jQuery('.floorplan.active');
    const $panzooms = $floorplan.find('.js-fp-panzoom');

    // Reset all panzoom instances and rotations
    $panzooms.each(function () {
      const panzoomInstance = this.panzoomInstance;
      if (panzoomInstance) panzoomInstance.reset();
      resetRotation(this);
    });

    // Toggle active state
    const $first = $panzooms.first();
    const $last  = $panzooms.last();

    if ($first.hasClass('active')) {
      $first.removeClass('active').hide();
      $last.addClass('active').show();
    } else {
      $last.removeClass('active').hide();
      $first.addClass('active').show();
    }

    // Initialize/update panzoom on the newly active element
    panControl('.js-fp-panzoom.active');
  });
  */

  jQuery('.js-flip-control').on('click', function () {
    const $activeFloorplan = jQuery('.floorplan.active');
    if (!$activeFloorplan.length) return;

    const $panzooms = $activeFloorplan.find('.js-fp-panzoom');
    if ($panzooms.length <= 1) return;

    // Reset all panzoom instances & rotations (within this floorplan only)
    $panzooms.each(function () {
      if (this.panzoomInstance) this.panzoomInstance.reset();
      resetRotation(this);
    });

    // Determine current active index INSIDE this floorplan
    let currentIndex = $panzooms.index(
      $panzooms.filter('.active')
    );

    // Fallback if none is active
    if (currentIndex === -1) currentIndex = 0;

    const nextIndex = (currentIndex + 1) % $panzooms.length;

    // Toggle visibility scoped to this floorplan
    $panzooms
      .removeClass('active')
      .hide()
      .eq(nextIndex)
      .addClass('active')
      .show();

    // Init/update panzoom for the new active instance
    panControl('.floorplan.active .js-fp-panzoom.active');
  });

  ///////////////////////////////////////////////////////////////
  // HEADER FILTER DROPDOWN - SHORTER TEXT SWAY ON MOBILE
  ///////////////////////////////////////////////////////////////
  jQuery(function($) {
    function updateSelectLabels() {
      const isMobile = window.innerWidth < 1400;

      $('select.swap-on-mobile').each(function() {
        const $select = $(this);
        const $defaultOption = $select.find('option').first();

        // store original text once
        if (!$select.data('orig-text')) {
          $select.data('orig-text', $defaultOption.text().trim());
        }

        const mobileText = $select.attr('mobtxt');
        const originalText = $select.data('orig-text');

        if (isMobile && mobileText) {
          $defaultOption.text(mobileText);
        } else {
          $defaultOption.text(originalText);
        }
      });
    }

    // Run on load and resize
    updateSelectLabels();
    $(window).on('resize', updateSelectLabels);
  });



  ////////////////////////////////////////////////////////////////////////
  // BOLD DROPDOWN TITLE
  ////////////////////////////////////////////////////////////////////////
  jQuery(function ($) {
    $('select.form-select').on('chosen:showing_dropdown', function () {
      const $select = $(this);
      const defaultIndex = $select.find('option[default]').index();

      if (defaultIndex !== -1) {
        $select
          .next('.chosen-container')
          .find('.chosen-results li')
          .eq(defaultIndex)
          .addClass('text-bold');
      }
    });
  });


  ////////////////////////////////////////////////////////////////////////////////////
  // Detect bottom space when form-select (chosen) dropdown opens
  ////////////////////////////////////////////////////////////////////////////////////
  jQuery(function ($) {
    $(document).on('chosen:showing_dropdown', '.form-select', function () {
      const $container = $(this).next('.chosen-container');
      const $dropdown  = $container.find('.chosen-drop');

      const viewportBottom = $(window).scrollTop() + $(window).height();
      const containerBottom = $container.offset().top + $container.outerHeight();
      const dropdownHeight = $dropdown.outerHeight();

      if (viewportBottom - containerBottom < dropdownHeight) {
        $container.addClass('chosen-drop-up');
      } else {
        $container.removeClass('chosen-drop-up');
      }
    });
  });
  


  ////////////////////////////////////////////////////////////////////////
  // KNOWLEDGE CENTRE
  ////////////////////////////////////////////////////////////////////////
  if (jQuery('.knowledge_centre_modal').length > 0) {

    jQuery(document).on('click', '.js-knowledge_centre_modal_close', function () {
      jQuery(this).closest('.knowledge_centre_modal').hide(300);
    });

    var brochureUrl = null;

    jQuery(document).on('click', '.js-knowledge-centre-brochure-download', function (e) {
      e.preventDefault();
      brochureUrl = jQuery(this).data('url');
      var modal = jQuery('.js-knowledge_centre_modal');
      var formId = modal.data('form-id');

      // ✅ Reset Gravity Form safely
      if (typeof gformResetForm === 'function' && formId) {
        gformResetForm(formId);
      }

      modal.show(300);
    });

    /*
    jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
      var modalFormId = jQuery('.js-knowledge_centre_modal').data('form-id');
      if (parseInt(formId) === parseInt(modalFormId) && brochureUrl) {
        window.open(brochureUrl, '_blank');
        brochureUrl = null; // reset so it doesn't reuse old URL
      }
    });
    */
   
  }

  ////////////////////////////////////////////////////////////////////////
  // AOS - RECALCULATE ON LOAD
  ////////////////////////////////////////////////////////////////////////
  document.addEventListener("DOMContentLoaded", function () {
    AOS.init({
      once: true,
      duration: 800
    });

    // Recalculate after page fully loads
    window.addEventListener('load', function () {
      AOS.refresh();
    });
  });





  ////////////////////////////////////////////////////////////////////////
  // FAVOURITES PAGE - INIT & EVENTS
  ////////////////////////////////////////////////////////////////////////
  (function($){
    $(function(){
      var $container = $('.js-favourite-designs');
      if (!$container.length) return;

      $.ajax({
        //url: HallmarkFavs.ajaxUrl,
        url: '/wp-admin/admin-ajax.php',
        type: 'POST',
        data: {
          action: 'nous_get_favourite_designs'
        },
        success: function(res){
          if(res.success){
            $container.html(res.data.html);
          } else {
            $container.html('<p>Error loading favourites.</p>');
          }
        },
        error: function(){
          $container.html('<p>Error loading favourites.</p>');
        }
      });

    });
  })(jQuery);


  // The favourites list renders over AJAX, so remove buttons are delegated.
  // nousFavourites writes the cookie and updates the count.
  $(document).on('click', '.js-remove-favourite', function(e) {
    e.preventDefault();

    var btn = $(this);
    window.nousFavourites.remove(String(btn.data('hd-pid')));
    btn.closest('.js-card-hd-favourite-wrapper-wrapper').remove();
  });



  ////////////////////////////////////////////////////////////////////////
  // READMORE EXPANDER
  ////////////////////////////////////////////////////////////////////////
  function getClampedHeightFromClone(originalEl, lines) {
    const parent = originalEl.parentElement;
    if (!parent) return 0;
    const clone = originalEl.cloneNode(true);

    // Put clone in the same container so it inherits exact width/typography context
    clone.style.position = 'absolute';
    clone.style.left = '0';
    clone.style.top = '0';
    clone.style.width = '100%';
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none';
    clone.style.zIndex = '-1';

    // Clamp the clone
    clone.style.overflow = 'hidden';
    clone.style.display = '-webkit-box';
    clone.style.webkitBoxOrient = 'vertical';
    clone.style.webkitLineClamp = String(lines);

    // Ensure parent can position absolute children without affecting layout
    const parentCS = window.getComputedStyle(parent);
    const parentWasStatic = parentCS.position === 'static';
    if (parentWasStatic) parent.style.position = 'relative';

    parent.appendChild(clone);
    const height = Math.ceil(clone.getBoundingClientRect().height);
    parent.removeChild(clone);

    // Restore parent positioning if we changed it
    if (parentWasStatic) parent.style.position = '';

    return height;
  }

  function isReadmoreMobile() {
    return $(window).width() <= 991;
  }

  function enableReadmore() {
    $('.js-readmore-content').each(function () {
      var content = this;
      var $content = $(this);

      var $btn = $content.parent().find('.js-readmore-toggle').first();
      if (!$btn.length) return;

      var lines = parseInt($content.attr('data-lines'), 10);
      if (!Number.isInteger(lines) || lines <= 0) return;

      $btn.removeClass('d-none').addClass('collapsed');

      content.style.overflow = 'hidden';
      content.style.transition = 'max-height 350ms ease';

      var collapsedMax = getClampedHeightFromClone(content, lines);
      var fullHeight = Math.ceil(content.scrollHeight);

      if (fullHeight <= collapsedMax + 2) {
        content.style.maxHeight = 'none';
        $btn.hide();
        return;
      }

      content.style.maxHeight = collapsedMax + 'px';
      $content.attr('data-collapsed-max', collapsedMax);
      $content.attr('data-state', 'collapsed');
      $btn.find('span').first().text('Read more');

    });
  }

  function disableReadmore() {
    $('.js-readmore-content').each(function () {
      var $content = $(this);

      $content.removeAttr('style data-state data-collapsed-max');

      // Find button reliably (no next-sibling assumption)
      var $btn = $content.parent().find('.js-readmore-toggle').first();
      if (!$btn.length) $btn = $content.siblings('.js-readmore-toggle').first();
      if (!$btn.length) $btn = $content.next('.js-readmore-toggle');

      // Desktop: rely on d-none only (no inline display:none)
      $btn.addClass('d-none').removeClass('collapsed');
      $btn.css('display', ''); // clears any previous $btn.hide()
    });
  }


  if (isReadmoreMobile()) {
    enableReadmore();
  } else {
    disableReadmore();
  }

  // Init: collapse on page load using clamped clone height
  if (isReadmoreMobile()) {
    $('.js-readmore-content').each(function () {
      var content = this;            // DOM element (needed for getClampedHeightFromClone)
      var $content = $(this);

      var $btn = $content.parent().find('.js-readmore-toggle').first();
      if (!$btn.length) return;

      var lines = parseInt($content.attr('data-lines'), 10);
      if (!Number.isInteger(lines) || lines <= 0) return;

      // Set base styles once
      $btn.removeClass('d-none');
      content.style.overflow = 'hidden';
      content.style.transition = 'max-height 350ms ease';

      // Measure exact collapsed height via clamped clone
      var collapsedMax = getClampedHeightFromClone(content, lines);
      var fullHeight = Math.ceil(content.scrollHeight);

      // If it doesn't need collapsing, hide the button
      if (fullHeight <= collapsedMax + 2) {
        content.style.maxHeight = 'none';
        $btn.css('display', 'none');
        return;
      }

      content.style.maxHeight = collapsedMax + 'px';
      $content.attr('data-collapsed-max', String(collapsedMax));
      $content.attr('data-state', 'collapsed');
      $btn.find('span').first().text('Read more');
    });
  }


  // Click handler: smooth toggle
  $('.js-readmore-toggle').on('click', function () {
    var $btn = $(this);
    var $content = $btn.prev('.js-readmore-content');
    if (!$content.length) return;

    var collapsedMax = parseInt($content.attr('data-collapsed-max'), 10);
    if (!collapsedMax) return;

    if ($content.attr('data-state') === 'collapsed') {
      // Expand
      $content.css('max-height', $content[0].scrollHeight + 'px');
      $content.attr('data-state', 'expanded');

      $btn
        .removeClass('collapsed').find('span')
        .text('Read less');
    } else {
      // Collapse
      $content.css('max-height', collapsedMax + 'px');
      $content.attr('data-state', 'collapsed');

      $btn
        .addClass('collapsed').find('span')
        .text('Read more');
    }
  });

  // Recalculate on resize
  var readmoreResizeTimer;
  $(window).on('resize', function () {
    clearTimeout(readmoreResizeTimer);

    readmoreResizeTimer = setTimeout(function () {

      // DESKTOP: disable + reset
      if (!isReadmoreMobile()) {
        disableReadmore();
        return;
      }

      $('.js-readmore-content').each(function () {
        var $content = $(this);
        var lines = parseInt($content.attr('data-lines'), 10);
        if (!Number.isInteger(lines) || lines <= 0) return;
        
        var collapsedMax = getClampedHeightFromClone(this, lines);
        console.log('collapsedMax: ' + collapsedMax);

        $content.attr('data-collapsed-max', collapsedMax);
        $content.attr('data-state', 'collapsed');
        $content.siblings('.js-readmore-toggle')
        .removeClass('d-none')
        .css('display', '')
        .addClass('collapsed')
        .find('span')
        .text('Read more');

        // Only update max-height if currently collapsed
        if ($content.attr('data-state') === 'collapsed') {
          $content.css('max-height', collapsedMax + 'px');
        } else if ($content.attr('data-state') === 'expanded') {
          $content.css('max-height', this.scrollHeight + 'px');
        }
      });
    }, 300); // run after resize stops
  });
  


////////////////////////////////////////////////////////////////////////
// STICKY & ADAPTIVE HEIGHT (HD & HL FILTER BLOCK)
////////////////////////////////////////////////////////////////////////
(function ($) {
  const $block   = $('.js-filter-block');
  const $nav     = $('header > nav.navbar'); // Navbar height
  const extraGap = 60; // Combined spacing below and above the form
  const cls      = 'overlap';

  const mqDesktop = window.matchMedia('(min-width: 992px)');

  let ticking = false;

  function computeAndClamp() {
    const isDesktop = mqDesktop.matches;

    const viewportH = window.innerHeight;
    const navH      = $nav.outerHeight(true) || 0;
    const available = viewportH - navH - extraGap;

    $block.each(function () {
      const $b = $(this);
      const isOpenMobilePopup = $b.hasClass('active');

      const $scroller = $b.find('.form-group-scroller');

      // If we're on mobile and the popup is CLOSED, don't fight CSS max-height:0
      if (!isDesktop && !isOpenMobilePopup) {
        $b.removeClass(cls);
        $scroller.css({ 'max-height': '', 'overflow-y': '' });
        return;
      }

      // In chrome, get block height minus scroller visible height
      const chromeH = ($b.outerHeight(true) - $scroller.outerHeight(true)) || 0;

      // Get Content Height (Scroll height)
      const contentH = $scroller[0] ? $scroller[0].scrollHeight : 0;

      const shouldOverlap = (chromeH + contentH) > available;
      const scrollerMax   = Math.max(0, available - chromeH);

      $b.toggleClass(cls, shouldOverlap);

      if (shouldOverlap) {
        $scroller.css({
          'max-height': scrollerMax + 'px',
          'overflow-y': 'auto'
        });
      } else {
        $scroller.css({ 'max-height': '', 'overflow-y': '' });
      }
    });
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      computeAndClamp();
    });
  }

  requestUpdate();
  $(window).on('resize load scroll', requestUpdate);

  // Recompute when breakpoint changes
  if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', requestUpdate);
  else mqDesktop.addListener(requestUpdate); // Safari - old version

  // Content changes (Chosen, expanding sections, etc.)
  if (window.ResizeObserver) {
    const ro = new ResizeObserver(requestUpdate);
    $block.each(function () {
      const scroller = $(this).find('.form-group-scroller')[0];
      if (scroller) ro.observe(scroller);
    });
    $nav.each(function () { ro.observe(this); });
  }
})(jQuery);



  function updateMegaMenuPadding() {
    const $container = $('nav.navbar > .container');
    const $target = $('.mega-menu-contact-details');
    const $offset = 18;
    if (!$container.length || !$target.length) return;
    if (window.innerWidth >= 1200) {
      const rect = $container[0].getBoundingClientRect();
      const distance = (window.innerWidth - rect.right) + $offset;
      $target.css('padding-right', distance + 'px');
    } else {
      $target.css('padding-right', '');
    }
  }

  let megaMenuTimer;
  $(window).on('load resize', function () {
    clearTimeout(megaMenuTimer);
    megaMenuTimer = setTimeout(updateMegaMenuPadding, 50);
  });



/*-----------------------------------------------------------------*/
}); //Document Ready


jQuery(window).on('load', function () {
  jQuery('.section-page-header-front-page').addClass('show');
})





jQuery(document).ready(function ($) {
  $('.js-hd-floorplan-tabs').each(function () {
    const $tabs = $(this);
    const $select = $tabs.siblings('.js-hd-floorplan');

    // Pill click
    $tabs.on('click', '.hd-floorplan-tab', function () {
      const $button = $(this);
      const $options = $select.find('option');

      let value = $button.data('value');

      // For 3+ floorplans, "Options" points to the first middle floorplan
      if ($button.data('group') === 'options') {
        value = $options.slice(1, -1).first().val();
      }

      if (!value) return;

      $select
        .val(value)
        .trigger('change')
        .trigger('chosen:updated');
    });

    // Select / Chosen change
    $select.on('change', function () {
      const value = $(this).val();
      const $options = $(this).find('option');

      const firstValue = $options.first().val();
      const lastValue = $options.last().val();

      $tabs
        .find('.hd-floorplan-tab')
        .removeClass('active');

      if (value === firstValue) {
        $tabs
          .find('[data-value="' + value + '"]')
          .addClass('active');

      } else if (
        $options.length > 2 &&
        value !== lastValue
      ) {
        $tabs
          .find('[data-group="options"]')
          .addClass('active');

      } else {
        $tabs
          .find('[data-value="' + value + '"]')
          .addClass('active');
      }
    });

    // Initial sync
    $select.trigger('change');
  });
});



////////////////////////////////////////////////////////////////////////
// Allow specific Gravity Forms radio fields to be deselected by adding
// the "allow-radio-deselect" CSS class to the field.
////////////////////////////////////////////////////////////////////////
document.addEventListener('pointerdown', function (e) {
    const field = e.target.closest('.allow-radio-deselect');

    if (!field) {
        return;
    }

    const choice = e.target.closest('.gchoice');

    if (!choice) {
        return;
    }

    const radio = choice.querySelector('input[type="radio"]');

    if (!radio) {
        return;
    }

    radio.dataset.wasChecked = radio.checked ? 'true' : 'false';
});


document.addEventListener('click', function (e) {
    const field = e.target.closest('.allow-radio-deselect');

    if (!field) {
        return;
    }

    const choice = e.target.closest('.gchoice');

    if (!choice) {
        return;
    }

    const radio = choice.querySelector('input[type="radio"]');

    if (!radio) {
        return;
    }

    if (radio.dataset.wasChecked === 'true') {
        e.preventDefault();

        radio.checked = false;
        radio.dataset.wasChecked = 'false';

        radio.dispatchEvent(new Event('change', {
            bubbles: true
        }));
    }
});



////////////////////////////////////////////////////////////////////////
// Enable partial-word matching on Gravity Forms Chosen dropdowns
// using the `chosen-search-enabled` custom CSS class.
////////////////////////////////////////////////////////////////////////
if (window.gform && typeof window.gform.addFilter === 'function') {
    window.gform.addFilter('gform_chosen_options', function (options, $element) {
        if ($element.closest('.chosen-search-enabled').length) {
            options.search_contains = true;
        }
        return options;
    });
}